import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "app/hooks";
import { reIdThunks } from "./store/slice";
import { reIdSelectors } from "./store/selectors";

export function ReIdObjectDetectionCollector() {
    const dispatch = useAppDispatch();

    const shouldFetchFetchObjectDetections = useAppSelector(
        reIdSelectors.selectShouldFetchFetchObjectDetections,
    );

    const selectedObjectDetectionModelName = useAppSelector(
        reIdSelectors.selectSelectedObjectDetectionModelName,
    );

    useEffect(() => {
        if (
            !shouldFetchFetchObjectDetections ||
            !selectedObjectDetectionModelName
        ) {
            return;
        }

        const fetchCall = () => {
            dispatch(
                reIdThunks.reIdFetchObjectDetectionsEveryRangeAsync({
                    dossierId: shouldFetchFetchObjectDetections.dossierId,
                    timeRangeInSeconds: 10,
                    objectDetectionModelName: selectedObjectDetectionModelName,
                }),
            );
        };

        fetchCall();

        if (shouldFetchFetchObjectDetections.enableInterval) {
            const interval = setInterval(fetchCall, 5000);
            return () => clearInterval(interval);
        }
    }, [
        shouldFetchFetchObjectDetections,
        selectedObjectDetectionModelName,
        dispatch,
    ]);

    return <></>;
}
